import { useTranslation } from "react-i18next";
import useEvent from "react-use-event-hook";
import { useSetRecoilState } from "recoil";

import {
  ConfirmResult,
  ControlsApi,
  Log,
  productionLogStateAtom,
  productionPollGroupStateAtom,
  warnAndToastSimpleResult,
} from "@ryde/shared";

import { useModalConfirm } from "../../hooks-singletons/use-modal-confirm";

export const useClearProductionCache = (): {
  handleClearProductionCacheClick: () => Promise<void>;
} => {
  const { t } = useTranslation();
  const { confirmDialogResult } = useModalConfirm();
  const setProductionGroupState = useSetRecoilState(
    productionPollGroupStateAtom,
  );
  const setLogState = useSetRecoilState(productionLogStateAtom);

  const handleClearProductionCacheClick = useEvent(async (): Promise<void> => {
    const confirmed = await confirmDialogResult({
      title: t("rideProduction.clearApplicationCacheConfirmTitle"),
      message: t("rideProduction.clearApplicationCacheConfirmMessage"),
    });

    if (confirmed !== ConfirmResult.OK) {
      Log.infoAndToast(t("rideProduction.clearApplicationCacheCanceled"));
      return;
    }

    const clearInProduceBookingsCacheResult =
      await ControlsApi.clearInProduceBookingsCache();

    if (clearInProduceBookingsCacheResult?.success) {
      setProductionGroupState(undefined);
      setLogState(undefined);
      Log.successAndToast(t("rideProduction.clearApplicationCacheSuccess"));
    } else if (clearInProduceBookingsCacheResult) {
      warnAndToastSimpleResult(clearInProduceBookingsCacheResult, t);
    } else {
      Log.errorAndToast("No response from api");
    }
  });

  return { handleClearProductionCacheClick };
};
